<template>
  <ProjectPartnerList :project="project"/>
</template>

<script>
import ProjectPartnerList from '../../../../components/Relations/ProjectPartners/Panels/List'

export default {
  components: {ProjectPartnerList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
